export default "/images/vendor/flag-icons/flags/1x1/eac.svg?4c589cf0c0297a00e1d9db2f9dae3596";